import React, { useEffect, useRef, useState } from 'react'
import swal from "sweetalert"
import { Link, useHistory } from "react-router-dom"
import { Button, Col, Dropdown, DropdownButton, FormControl, InputGroup, Row, Form } from "react-bootstrap"
import { AddIconOutline, MenuDots, SearchIcon } from "../../components/SvgIcons"
import { toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import BarLoader from "react-spinners/BarLoader";
import { constants, customStyles, GENDERS } from "../../utils/constants";
import { DeleteUser, GetUsers } from "../../services/users.service";
import { EmptyLocalStorage } from "../../services/auth/auth.service";
import ImagePreview from "../../components/ImagePreview";
import moment from "moment";
import ExportCsv from "../../components/ExportCSV";

function Users() {
    let history = useHistory();
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(constants.PERPAGE);
    const [rows, setRows] = useState();
    const [keyword, setKeyword] = useState('');
    const [gender, setGender] = useState('');
    const [type, setType] = useState('');
    const [cohort, setCohort] = useState('');
    const [value, setValue] = useState('');
    const [email, setEmail] = useState(false);
    const [subscribed, setSubscribed] = useState(null);
    const typingTimeoutRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [allUsers, setAllUsers] = useState([]);

    useEffect(async () => {
        await getUsers();
        await exportUsers();
    }, [keyword, page, perPage, gender, value, subscribed, cohort, startDate, endDate])

    const calculateCohort = (selectedCohort) => {
        const now = moment();
        let start, end;

        switch (selectedCohort) {
            case 'Cohort 1':
                start = now.clone().subtract(6, 'days');
                end = now;
                break;
            case 'Cohort 2':
                start = now.clone().subtract(30, 'days');
                end = now.clone().subtract(7, 'days');
                break;
            case 'Cohort 3':
                start = now.clone().subtract(90, 'days');
                end = now.clone().subtract(31, 'days');
                break;
            case 'Cohort 4':
                start = now.clone().subtract(1, 'year');
                end = now.clone().subtract(91, 'days');
                break;
            case 'Cohort 5':
                start = now.clone().subtract(2, 'years');
                end = now.clone().subtract(1, 'year').add(1, 'day');
                break;
            case 'Cohort 6':
                start = now.clone().subtract(3, 'years');
                end = now.clone().subtract(2, 'years').add(1, 'day');
                break;
            default:
                start = null;
                end = null;
                break;
        }

        return {
            startDate: start.toDate(),
            endDate: end.toDate()
        };
    };

    const handleCohortChange = (e) => {
        const selectedCohort = e.target.value;
        setCohort(selectedCohort);

        const { startDate, endDate } = calculateCohort(selectedCohort);
        setStartDate(startDate);
        setEndDate(endDate);
    };


    const getUsers = async (paginate = true) => {
        setLoading(true)
        await GetUsers(email,
            keyword,
            page,
            perPage,
            paginate ? 1 : 0,  // is_paginate
            '', // status
            subscribed,
            startDate,
            endDate
        ).then((result) => {
            if (result?.status) {
                if (result?.data) {
                    const rowData = [];
                    const startIndex = (page - 1) * perPage;  // Starting index for the current page

                    setPage(result?.data?.pagination?.currentPage)
                    setTotalRows(result.data.pagination.total);
                    result.data.data.map((dt, index) => {
                        rowData.push({
                            serialNumber: startIndex + index + 1, // Calculate serial number
                            id: dt._id || '-',
                            name: dt.fullName || '-',
                            image: dt.profileImage || '-',
                            email: dt.email || '-',
                            // gender: GENDERS[dt?.gender] || '-',
                            dob: new Date(dt.additionalFields?.dob).toLocaleDateString("en-US", {
                                month: "2-digit",
                                day: "2-digit",
                                year: "numeric"
                            }) || '-',
                            // type: dt.type || '-',
                            address: dt.address || '-',
                            // user_package: dt.user_package && dt.user_package?.name || '-',
                            role: dt.role,
                            created_at: moment(dt.createdAt).fromNow(),
                            updated_at: (dt?.updatedAt ? moment(dt?.updatedAt).fromNow() : '-'),
                        });

                    })
                    setRows(rowData);
                    setLoading(false)
                }
            } else {
                setLoading(false)
                setRows([]);
            }
        }).catch((error) => {
            setLoading(false)
            if (error.response.status == 401) {
                EmptyLocalStorage()
                history.push('/');
            } else if (error.response.status == 404) {
                setRows([]);
            } else {
                return toast.error(error.response.data.message);
            }
        })
    }



    const exportUsers = async () => {
        await GetUsers(email,
            keyword,
            page,
            perPage,
            0,  // is_paginate
            '', // status
            subscribed,
            startDate,
            endDate
        ).then((result) => {
            if (result.status) {
                const rowData = [];
                result.data.map((dt, index) => {
                    rowData.push({
                        serialNumber: index + 1, // Calculate serial number
                        // id: dt._id || '-',
                        name: dt.fullName || '-',
                        // image: dt.profileImage || '-',
                        email: dt.email || '-',
                        // gender: GENDERS[dt?.gender] || '-',
                        dob: new Date(dt.additionalFields?.dob).toLocaleDateString("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            year: "numeric"
                        }) || '-',
                        city: dt.city?.name || '-',
                        state: dt.state?.name || '-',
                        // type: dt.type || '-',
                        address: dt.address || '-',
                        // user_package: dt.user_package && dt.user_package?.name || '-',
                        // role: dt.role,
                        created_at: moment(dt.createdAt).fromNow(),
                        updated_at: (dt?.updatedAt ? moment(dt?.updatedAt).fromNow() : '-'),
                    });

                })
                setAllUsers(rowData);
            }
            // Pass the users to the ExportCsv component
        });
    };


    const onUserDelete = (id) => {
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to delete this user?",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willShip) => {
            //Delete  API
            if (willShip) {
                await DeleteUser(id).then((result) => {
                    if (result.status) {
                        swal(result.message, {
                            icon: "success",
                        });
                        getUsers();
                    } else {
                        toast.error(result.message);
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        EmptyLocalStorage()
                        history.push('/');
                    } else {
                        return toast.error(error.response.data.message);
                    }
                })
            }
        });
    }

    const onEdit = (data) => {
        history.push('/manage-users/edit-user/' + data.id, {
            data: data
        });
    }

    const onView = (data) => {
        history.push('/manage-users/view-user/' + data.id, {
            data: data
        });
    }


    const userActions = (data) => {
        return (
            <DropdownButton align="end" className={"actionDropdown"} id="dropdown-item-button" title={<MenuDots />}>
                <Dropdown.Item as="button" onClick={() => onEdit(data)}>Edit</Dropdown.Item>
                <Dropdown.Item as="button" onClick={() => onView(data)}>View</Dropdown.Item>
                <Dropdown.Item as="button" onClick={() => onUserDelete(data.id)}>Delete</Dropdown.Item>
            </DropdownButton>
        )
    }

    const handleImageClick = (imageSrc) => {
        setSelectedImage(imageSrc);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const columns = [
        // {
        //     id: 'id',
        //     name: 'Id',
        //     maxWidth: '60px',
        //     center: true,
        //     sortable: true,
        //     selector: rowData => rowData.id,
        // },
        {
            id: 'serialNumber',
            name: 'S.No',
            maxWidth: '60px',
            center: true,
            sortable: false,
            selector: rowData => rowData.serialNumber,
        },
        {
            id: 'image',
            name: 'Image',
            maxWidth: '100px',
            center: true,
            selector: rowData => rowData.image,
            format: rowData => <img src={rowData.image}
                onClick={() => handleImageClick(rowData.image)}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = constants.IMAGENOTFOUND;
                }}
                alt={'Broken'}
                className={"img-table img-thumbnail"} crossOrigin={"anonymous"} />
        },
        {
            id: 'full_name',
            name: 'Name',
            maxWidth: '160px',
            sortable: true,
            selector: rowData => rowData.name,
        },
        {
            id: 'email',
            name: 'Email',
            minWidth: '180px',
            selector: rowData => rowData.email,
        },
        {
            id: 'dob',
            name: 'DOB',
            maxWidth: '100px',
            center: true,
            selector: rowData => rowData.dob,
        },
        {
            id: 'updated_at',
            name: 'Updated At',
            grow: false,
            center: true,
            selector: rowData => rowData.updated_at,
        },
        {
            id: 'created_at',
            name: 'Created At',
            grow: false,
            center: true,
            selector: rowData => rowData.created_at,
        },
        {
            id: 'action',
            name: 'Action',
            center: true,
            cell: rowData => userActions(rowData)
        },
    ];


    const filterFrom = async (value) => {
        setValue(value)
        if (value == 1) {
            setEmail(true)
        } else {
            setEmail(false)
        }

    }

    const handleKeyUp = (e) => {
        clearTimeout(typingTimeoutRef.current);

        const value = e.target.value;
        if (value.length > 2) {
            typingTimeoutRef.current = setTimeout(() => {
                setKeyword(value);
            }, 500); // Set keyword after 500 milliseconds of inactivity
        } else {
            setKeyword(null);
        }
    };

    return (
        <div className={"usersPage"}>
            {/*<h1 className="page-heading">Users ({totalRows})</h1>*/}
            <h1 className="page-heading">Users</h1>

            <hr />
            <ExportCsv exportRows={allUsers} fileName="users" />
            <div className={"customOrderFilters"}>
                <Row>
                    <Col xs={12} sm={12} md={4} lg={4} xl={4}>
                        <InputGroup className="mb-3 search-group">
                            <InputGroup.Text id="basic-addon1"><SearchIcon /></InputGroup.Text>
                            <FormControl
                                placeholder="Search"
                                aria-label="Search"
                                aria-describedby="Search"
                                maxLength={"255"}
                                onKeyUp={handleKeyUp}
                            />
                        </InputGroup>
                    </Col>

                    <Col xs={12} sm={12} md={3} lg={3} xl={3}>
                        <Form.Select
                            className="mb-3"
                            onChange={(e) => setSubscribed(e.target.value === '' ? null : Number(e.target.value))}
                            value={subscribed === null ? '' : subscribed}
                        >
                            <option value="">All Users</option>
                            <option value="1">Subscribed</option>
                            <option value="0">Not Subscribed</option>
                        </Form.Select>
                    </Col>
                    <Col xs={12} sm={12} md={3} lg={3} xl={3}>
                        <Form.Select
                            className="mb-3"
                            onChange={handleCohortChange}
                            value={cohort}
                        >
                            <option value="">All Cohorts</option>
                            <option value="Cohort 1">Cohort 1 (Last 7 days)</option>
                            <option value="Cohort 2">Cohort 2 (8-30 days)</option>
                            <option value="Cohort 3">Cohort 3 (31-90 days)</option>
                            <option value="Cohort 4">Cohort 4 (91-365 days)</option>
                            <option value="Cohort 5">Cohort 5 (1-2 years)</option>
                            <option value="Cohort 6">Cohort 6 (2-3 years)</option>
                        </Form.Select>

                    </Col>
                    {/* <Col xs={12} sm={12} md={{ span: 2, offset: 2 }} lg={{ span: 2, offset: 2 }} xl={{ span: 2, offset: 2 }}> */}

                    {/* </Col> */}
                    <Col xs={12} sm={12} md={2} lg={2} xl={2}>
                        <Link to={"/manage-users/add-user"}>
                            <Button className={"btn btn-green-theme h40 w-100 mb-md-0 mb-sm-3 mb-3"}>
                                <AddIconOutline /> Add New
                            </Button>
                        </Link>
                    </Col>
                </Row>

            </div>
            <div className="theme-dataGrid products-dataGrid">
                <DataTable
                    pagination
                    columns={columns}
                    data={rows}
                    // actions={actionsMemo}
                    // data={data}
                    progressPending={loading}
                    customStyles={customStyles}
                    selectableRows={false}
                    striped
                    highlightOnHover
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={perPage}
                    onChangePage={(page) => {
                        setPage(page);
                    }}
                    onChangeRowsPerPage={(currentRowsPerPage) => {
                        setPerPage(currentRowsPerPage)
                    }}
                    progressComponent={<BarLoader color={'#41D2D2'} loading={loading} css={'marginTop: 10px'}
                        height={'4'} width={'100%'} />}
                />
            </div>
            <ImagePreview
                show={showModal}
                onHide={handleCloseModal}
                size="lg"
                content={selectedImage}
            />
        </div>
    )
}

export default Users
